import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';

interface PrivateLayoutProps {
  children?: React.ReactNode;
  hideHeader?: boolean;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children, hideHeader }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-orange-900 to-slate-900">
      {!hideHeader && <AppHeader />}
      <main className={`${hideHeader ? 'min-h-screen' : 'min-h-[calc(100vh-80px)]'} overscroll-none`}>
        {children || <Outlet />}
      </main>
    </div>
  );
};

export default PrivateLayout;

